import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const TenantFormComponent = lazy (
    () => import('../components/TenantForm')
);

const TenantFormRoute: RouteObject = {
    path: 'create-tenant',
    element: <TenantFormComponent />,
}

export default TenantFormRoute;